function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const ALL_QUESTIONS = [
  {
    id: 1,
    answer: 'Tiger',
    clues: [
      'I have orange fur with black stripes.',
      'I am the national animal of India.',
      'I am the biggest cat in Asia.',
      'I love to swim in rivers and lakes.',
    ],
    options: ['Lion', 'Tiger', 'Leopard', 'Cheetah'],
    correctIndex: 1,
  },
  {
    id: 2,
    answer: 'Peacock',
    clues: [
      'I have beautiful blue and green feathers.',
      'I am the national bird of India.',
      'I dance when it rains.',
      'My tail feathers have eye-shaped spots.',
    ],
    options: ['Parrot', 'Eagle', 'Peacock', 'Flamingo'],
    correctIndex: 2,
  },
  {
    id: 3,
    answer: 'Elephant',
    clues: [
      'I am the largest land animal in India.',
      'I have a long trunk and big ears.',
      'I love to eat leaves, grass and bananas.',
      'People ride on my back in festivals.',
    ],
    options: ['Elephant', 'Rhinoceros', 'Hippopotamus', 'Buffalo'],
    correctIndex: 0,
  },
  {
    id: 4,
    answer: 'King Cobra',
    clues: [
      'I am the longest venomous snake in the world.',
      'I can spread a hood around my head.',
      'Snake charmers used to play music for me.',
      'I am found in the forests of India.',
    ],
    options: ['Python', 'Viper', 'King Cobra', 'Rat Snake'],
    correctIndex: 2,
  },
  {
    id: 5,
    answer: 'Asiatic Lion',
    clues: [
      'I am called the King of the Jungle.',
      'I have a big golden mane around my face.',
      'In India, I live only in Gujarat.',
      'My home is the Gir Forest.',
    ],
    options: ['Tiger', 'Leopard', 'Asiatic Lion', 'Wolf'],
    correctIndex: 2,
  },
  {
    id: 6,
    answer: 'Monkey',
    clues: [
      'I love to jump from tree to tree.',
      'I have a long curly tail.',
      'I steal food from people sometimes!',
      'You can see me near temples in India.',
    ],
    options: ['Squirrel', 'Monkey', 'Lemur', 'Bat'],
    correctIndex: 1,
  },
  {
    id: 7,
    answer: 'Parrot',
    clues: [
      'I am a bright green bird.',
      'I have a curved red beak.',
      'I can learn to copy human words!',
      'People keep me as a pet in India.',
    ],
    options: ['Sparrow', 'Crow', 'Parrot', 'Pigeon'],
    correctIndex: 2,
  },
  {
    id: 8,
    answer: 'Ganges River Dolphin',
    clues: [
      'I live in the rivers of India.',
      'I am almost blind but I use sound to find food.',
      'I am a mammal, not a fish!',
      'I am found in the Ganga river.',
    ],
    options: ['Shark', 'Whale', 'Ganges River Dolphin', 'Crocodile'],
    correctIndex: 2,
  },
  {
    id: 9,
    answer: 'Indian Rhinoceros',
    clues: [
      'I have one horn on my nose.',
      'My skin looks like armour plates.',
      'I live in Assam, in Kaziranga.',
      'I am one of the biggest animals in India.',
    ],
    options: ['Elephant', 'Indian Rhinoceros', 'Hippopotamus', 'Wild Boar'],
    correctIndex: 1,
  },
  {
    id: 10,
    answer: 'Camel',
    clues: [
      'I am called the Ship of the Desert.',
      'I can survive many days without water.',
      'I have a big hump on my back.',
      'You will find me in Rajasthan.',
    ],
    options: ['Horse', 'Donkey', 'Camel', 'Yak'],
    correctIndex: 2,
  },
  {
    id: 11,
    answer: 'Flamingo',
    clues: [
      'I am a tall pink bird.',
      'I stand on one leg in the water.',
      'Thousands of us visit Gujarat every winter.',
      'I eat tiny shrimp which make me pink!',
    ],
    options: ['Crane', 'Flamingo', 'Pelican', 'Stork'],
    correctIndex: 1,
  },
  {
    id: 12,
    answer: 'Spotted Deer',
    clues: [
      'I have beautiful white spots on my brown body.',
      'I live in the forests of India.',
      'I am also called Chital.',
      'Tigers like to hunt me.',
    ],
    options: ['Spotted Deer', 'Antelope', 'Nilgai', 'Sambar'],
    correctIndex: 0,
  },
  {
    id: 13,
    answer: 'Sloth Bear',
    clues: [
      'I have long shaggy black fur.',
      'I love to eat honey and ants.',
      'I have a white V-shape on my chest.',
      'Baloo from The Jungle Book is based on me!',
    ],
    options: ['Polar Bear', 'Sloth Bear', 'Panda', 'Brown Bear'],
    correctIndex: 1,
  },
  {
    id: 14,
    answer: 'Kingfisher',
    clues: [
      'I am a small bird with very bright colours.',
      'I dive into water to catch fish.',
      'My feathers are blue and orange.',
      'I sit quietly on branches near rivers.',
    ],
    options: ['Robin', 'Woodpecker', 'Kingfisher', 'Hummingbird'],
    correctIndex: 2,
  },
  {
    id: 15,
    answer: 'Owl',
    clues: [
      'I can turn my head almost all the way around.',
      'I hunt at night when everyone is sleeping.',
      'I have very big round eyes.',
      'In India, people think I am very wise.',
    ],
    options: ['Bat', 'Owl', 'Eagle', 'Vulture'],
    correctIndex: 1,
  },
  {
    id: 16,
    answer: 'Hornbill',
    clues: [
      'I have a very large and colourful beak.',
      'There is a bump on top of my beak called a casque.',
      'I live in the forests of North East India.',
      'Nagaland celebrates a festival named after me!',
    ],
    options: ['Toucan', 'Hornbill', 'Pelican', 'Woodpecker'],
    correctIndex: 1,
  },
  {
    id: 17,
    answer: 'Gharial',
    clues: [
      'I look like a crocodile but I am different.',
      'I have a very long and thin snout.',
      'I eat only fish.',
      'I live in the rivers of North India.',
    ],
    options: ['Crocodile', 'Alligator', 'Gharial', 'Komodo Dragon'],
    correctIndex: 2,
  },
  {
    id: 18,
    answer: 'Indian Eagle',
    clues: [
      'I am a large bird with very sharp eyes.',
      'I fly very high in the sky.',
      'I catch small animals with my strong claws.',
      'I am a symbol of power and freedom.',
    ],
    options: ['Hawk', 'Indian Eagle', 'Vulture', 'Kite'],
    correctIndex: 1,
  },
  {
    id: 19,
    answer: 'Red Panda',
    clues: [
      'I am small and cute with reddish-brown fur.',
      'I have a bushy striped tail.',
      'I live in the Himalayan forests of India.',
      'I am not actually related to the Giant Panda!',
    ],
    options: ['Fox', 'Raccoon', 'Red Panda', 'Squirrel'],
    correctIndex: 2,
  },
  {
    id: 20,
    answer: 'Crocodile',
    clues: [
      'I have a very strong jaw with sharp teeth.',
      'I hide in rivers waiting for my food.',
      'My skin is rough and scaly.',
      'I am found in many rivers and lakes of India.',
    ],
    options: ['Gharial', 'Turtle', 'Crocodile', 'Lizard'],
    correctIndex: 2,
  },
];

export function getRandomWhoAmIQuestions(count = 10) {
  return shuffle(ALL_QUESTIONS).slice(0, count);
}
